import { Component } from 'react';
import { connect } from "react-redux";
import axios from "axios";
import FormTemplate from "../common/form/FormTemplate";
import { FileUploadTenantAdminKey } from "../../redux/actions/tenantAdminActions";

import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES, ALERT_TYPES } from "../constants/constants";
import Alert from '../common/modal/Alert';

const componentName = FileUploadTenantAdminKey;

// const matchDispatchToProps = (dispatch) => {
//   return {
//     setSelectedTenantAdminType: () => dispatch(setSelectedTenantAdminType(componentName))
//   }
// }

class FileUpload extends Component {

  state = {
    lastUpload: '',
    uploadedFile: '',
    selectedFile: null,
    fileKey: '',
    languages: false,
    message: "",
    loadingStatus: '',
    showAlert: false,
    alertMessage: "",
    redirect: false,
    alertType:ALERT_TYPES.OK,
    errors: []
  }

    showLoading = () => {
      if (this.state.loadingStatus === "") {
        this.setState({
          loadingStatus: LOADING_STATUES.LOADING
        })
        return true;
      }
      return false;
    }

  showAlert = (alertMessage, alertType=ALERT_TYPES.OK) => {
    this.setState({
      showAlert: true,
      alertMessage,
      alertType
    })
  }

  hideAlert = () => {
    this.setState({
      showAlert: false,
      alertMessage: ""
    });

    if (this.state.redirect) {
			this.props.history.push('/tenantAdmin/fileUploads');
		}
  }

  handleSubmit = (event) => {
    event.preventDefault();
    // if (this.validate()) {
    const formData = new FormData();
    formData.append("file", this.state.selectedFile);

    const allowedFormats = new Set(["text/csv"]);

    if (!allowedFormats.has(this.state.selectedFile.type)) {
      this.setState(
        { errors: { 'uploadedFile': 'Invalid format type.' } }
      );
      return false;
    }

    if (this.state.selectedFile.size > 25000000) {
      this.setState(
        { errors: { 'uploadedFile': 'File exceends the max size.' } }
      );
      return false;
    }

    if (this.showLoading()) {
      axios({ method: "post", url: configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/fileUpload", data: formData, headers: { "Content-Type": "multipart/form-data" }, withCredentials: true })
        .then((response) => {
        	  this.setState({ loadingStatus: "", redirect: true },  this.showAlert(response.data.message));
        }, (error) => {
            this.setState({ loadingStatus: "", redirect: false },  this.showAlert(error.response.data.message, ALERT_TYPES.WARNING));
        });
    }
  }

  handleChange = (event) => {
    let value = event.target.value;
    value = value === "true" || value === "false" ? JSON.parse(event.target.value) : value;
    this.setState({
      status: "",
      message: "",
      [event.target.id]: value ? value : (event.target.type === 'number' ? 0 : value)
    })
  }

  // On file select (from the pop up)
  onFileChange = event => {
    this.setState({ selectedFile: event.target.files[0], errors: {} });
  };

  componentDidMount() {
    axios.get(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/fileUploadLast", { withCredentials: true })
      .then(
        (response) => {
          const content = response.data.content;
          this.setState({
            lastUpload: content.fileName ? content.fileName + ' ' + content.submittedTimestampFormatted : 'N/A',
            status: ""
          });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  render() {

    const formProps = {
      componentName: componentName,
      pageHeading: "File Upload",
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      successIndicator: this.state.status === LOADING_STATUES.SUCCESS,
      loadingIndicator: this.state.status === LOADING_STATUES.LOADING,
      message: this.state.message,
      formGroupRows: [
        {
          formGroups: [{ id: 'uploadedFile', fieldType: 'file', label: 'File', key: this.state.fileKey, onChange: this.onFileChange, error: this.state.errors['uploadedFile'] }]
        },
        {
          formGroups: [{ id: 'lastUploaded', fieldType: 'textlike', label: 'Last Uploaded', disabled: true, value: 'Last Upload - ' + this.state.lastUpload }]
        }
      ]
    }

    return (
      <>
        <FormTemplate {...formProps} />
        <Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType}/>
      </>
    );
  }
}

export default FileUpload;